if (!customElements.get('s-featured-product')) {
  customElements.define(
    's-featured-product',
    class FeaturedProduct extends HTMLElement {
      constructor() {
        super();
        this.mainSlider = this.querySelector(`.slider-${this.productId}`);
        this.thumbSlider = this.querySelector(`.thumb-${this.productId}`);
        this.variants = this.querySelectorAll('[data-variant-id]');
        this.priceContainer = this.querySelector('[data-price]');
        this.comparePriceContainer = this.querySelector('[data-compare-price]');
        this.discountContainer = this.querySelector('[data-discount]');
        this.variantInput = this.querySelector('input[name="id"]');
        this.productForm = this.querySelector(`#product_form_${this.productId}`);
      }

      get productId() {
        return this.dataset.id;
      }

      get productHandle() {
        return this.dataset.handle;
      }

      get currencySymbol() {
        return this.dataset.currency;
      }

      #state = {
        product: null,
      };

      connectedCallback() {
        this.getProductData();
        this.initSliders();
        this.initVideoPlaying();
        this.selectVariant();
        this.addToCart();
      }

      async getProductData() {
        const url = `${window.Shopify.routes.root}products/${this.productHandle}?view=get-product-json`;
        const response = await fetch(url);
        const result = await response.json();
        this.#state.product = result;
      }

      initSliders() {
        if (!this.mainSlider && !this.thumbSlider) return;
        const prevButton = this.mainSlider.querySelector('[data-prev]');
        const nextButton = this.mainSlider.querySelector('[data-next]');

        const thumbSliderSettings = {
          slidesPerMove: 1,
          slidesPerView: 6.5,
          spaceBetween: 8,
          slidesOffsetAfter: 8,
          speed: 500,
          freeMode: true,
          watchSlidesProgress: true,
          slideToClickedSlide: false,
          breakpoints: {
            768: {
              slidesPerView: 7.7,
            },
          },
        };

        const thumbSlider = new Swiper(this.thumbSlider, thumbSliderSettings);
        const mainSliderSettings = {
          slidesPerView: 1,
          slidesPerMove: 1,
          speed: 500,
          navigation: {
            nextEl: nextButton,
            prevEl: prevButton,
          },
          thumbs: {
            swiper: thumbSlider,
          },
        };
        new Swiper(this.mainSlider, mainSliderSettings);
      }

      initVideoPlaying() {
        const videos = this.mainSlider.querySelectorAll('video');
        if (videos.length === 0) return;
        videos.forEach((video) => {
          this.observVideo(video);
        });
      }

      selectVariant() {
        if (this.variants.length === 0 || !this.productForm) return;
        this.variants.forEach((variant) => {
          variant.addEventListener('click', () => {
            const variantId = Number(variant.dataset.variantId);
            const selectedVariant = this.#state.product.variants.find((variant) => variant.id === variantId);
            if (!this.#state.product) return;
            if (!selectedVariant) return;
            this.variants.forEach((variant) => variant.classList.remove('active'));
            variant.classList.add('active');
            this.variantInput.value = variantId;
            this.priceContainer.innerHTML = this.formatPrice(selectedVariant.price);
            this.comparePriceContainer.innerHTML =
              selectedVariant.compare_at_price && selectedVariant.compare_at_price > selectedVariant.price ? this.formatPrice(selectedVariant.compare_at_price) : '';
            this.discountContainer.innerHTML =
              selectedVariant.compare_at_price && selectedVariant.compare_at_price > selectedVariant.price ? this.discount(selectedVariant.price, selectedVariant.compare_at_price) : '';
          });
        });
      }

      addToCart() {
        this.productForm.addEventListener('submit', async (event) => await this.addToCartHandler(event));
      }

      async addToCartHandler(event) {
        event.preventDefault();
        const url = `${Shopify.routes.root}cart/add.js`;
        const formData = new FormData(this.productForm);
        let sectionsToBundle = new Set();
        document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: sectionsToBundle } }));
        formData.set('sections', [...sectionsToBundle].join(','));

        const request = {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Access-Control-Allow-Origin': 'no-cors',
          },
          body: formData,
        };

        const response = await fetch(url, request);
        const result = await response.json();

        if (response.ok) {
          const cartContent = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
          cartContent['sections'] = result['sections'];
          const items = result.hasOwnProperty('items') ? result['items'] : [result];
          this.productForm.dispatchEvent(
            new CustomEvent('variant:add', {
              bubbles: true,
              detail: {
                items,
                cart: cartContent,
              },
            }),
          );
          document.documentElement.dispatchEvent(
            new CustomEvent('cart:change', {
              bubbles: true,
              detail: {
                baseEvent: 'variant:add',
                cart: cartContent,
              },
            }),
          );
        }
      }

      observVideo(video) {
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                video.play();
              } else {
                video.pause();
              }
            });
          },
          { threshold: 0.9 },
        );
        observer.observe(video);
      }

      formatPrice(price) {
        const formattedPrice = (price / 100).toLocaleString('en-EU', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });
        return `${String(formattedPrice).replace('.', ',')}${this.currencySymbol}`;
      }

      discount(price, comparePrice) {
        const pricePercent = Math.round((price * 100) / comparePrice);
        return `-${100 - pricePercent}%`;
      }
    },
  );
}
